import React from 'react';

const XIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.747l7.73-8.835L1.254 2.25H8.08l4.259 5.631 5.905-5.631Zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

const LinkedInIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
  </svg>
);

const MailIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <rect x="2" y="4" width="20" height="16" rx="2" />
    <path d="m2 7 10 7 10-7" />
  </svg>
);

export default function ContactPage() {
  return (
    <div className="page-top-pad">
      <section className="section section-dark" style={{ minHeight: 'calc(100vh - 5rem)', paddingTop: '5rem' }}>
        <div className="section-label" style={{ color: 'var(--gold)' }}>Get in Touch</div>
        <h1 className="section-title section-title-light">Let's Connect</h1>

        <div className="contact-grid">
          {/* ── Left: links ── */}
          <div>
            <p className="contact-body">
              I'm always open to conversations about enterprise technology strategy, AI adoption,
              digital leadership, and inclusive workplace culture. Whether you're an IT leader
              navigating a transformation or simply interested in exchanging ideas — feel free to
              reach out via any of the channels below.
            </p>

            <div className="contact-links">
              <a className="contact-link" href="mailto:bipin514@gmail.com">
                <div className="contact-link-icon"><MailIcon /></div>
                <div>
                  <div style={{ fontWeight: 500, fontSize: '0.88rem', marginBottom: '0.1rem' }}>Email</div>
                  <div style={{ fontSize: '0.82rem', opacity: 0.7 }}>bipin514@gmail.com</div>
                </div>
              </a>

              <a className="contact-link" href="https://www.linkedin.com/in/bipinsasi" target="_blank" rel="noreferrer">
                <div className="contact-link-icon"><LinkedInIcon /></div>
                <div>
                  <div style={{ fontWeight: 500, fontSize: '0.88rem', marginBottom: '0.1rem' }}>LinkedIn</div>
                  <div style={{ fontSize: '0.82rem', opacity: 0.7 }}>linkedin.com/in/bipinsasi</div>
                </div>
              </a>

              <a className="contact-link" href="https://x.com/BipinSasi" target="_blank" rel="noreferrer">
                <div className="contact-link-icon"><XIcon /></div>
                <div>
                  <div style={{ fontWeight: 500, fontSize: '0.88rem', marginBottom: '0.1rem' }}>X (Twitter)</div>
                  <div style={{ fontSize: '0.82rem', opacity: 0.7 }}>@BipinSasi</div>
                </div>
              </a>
            </div>

            <div className="contact-location">
              <div className="contact-location-label">Based in</div>
              <div className="contact-location-text">
                Bengaluru, Karnataka, India<br />
                Open to global conversations
              </div>
            </div>
          </div>

          {/* ── Right: endorsement ── */}
          <div className="endorsement">
            <div className="endorsement-label">Management Endorsement</div>
            <p className="endorsement-quote">
              "Bipin's leadership, deep hands-on expertise in software development, and ability to
              translate complex problems into practical, scalable solutions have been central to
              building the foundation we stand on today. As Group IT continues to evolve its
              operating model, it became clear that Bipin's strengths and experience are needed
              even more urgently within the Business Domain Solutions space."
            </p>
            <div className="endorsement-author">Senior Leadership · Merck Group IT · April 2026</div>
            <hr className="endorsement-divider" />
            <div className="endorsement-note">
              Bachelor's in Computer Science · 15+ years enterprise IT<br />
              Fluent: English, Hindi, Malayalam
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
